export default __webpack_public_path__ + "static/media/07_photo.0b065bae.jpg";